// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-actions-menu-sub-content {
  min-width: 200px;
  max-width: 512px;
  padding: 4px 0;
  border-radius: 8px;
  background-color: var(--color-popover-background);
  box-shadow: 0px 0px 2px 0px var(--color-shadow-base), 0px 2px 10px 0px var(--color-shadow-base);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  display: flex;
  flex-direction: column;
  max-height: calc(var(--radix-dropdown-menu-content-available-height) - 16px);
}
.n-actions-menu-sub-content__scroll-area {
  display: flex;
  overflow: hidden;
}
.n-actions-menu-sub-content__scroll-area-viewport {
  height: auto;
}
.n-actions-menu-sub-content[data-side="top"] {
  margin-bottom: 4px;
  animation-name: slideDownAndFade;
}
.n-actions-menu-sub-content[data-side="bottom"] {
  margin-top: 4px;
  animation-name: slideUpAndFade;
}
.n-actions-menu-sub-content[data-side="right"] {
  margin-left: 4px;
  animation-name: slideLeftAndFade;
}
.n-actions-menu-sub-content[data-side="left"] {
  margin-right: 4px;
  animation-name: slideRightAndFade;
}
.n-actions-menu-sub-content__header {
  padding: 4px 8px;
  width: 100%;
}
@keyframes slideUpAndFade {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideRightAndFade {
  from {
    opacity: 0;
    transform: translateX(-12px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideDownAndFade {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideLeftAndFade {
  from {
    opacity: 0;
    transform: translateX(12px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/actions-menu/ActionsMenuSubContent.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/popover.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;ECCE,gBAAA;EACA,gBAAA;EAEA,cAAA;EAEA,kBAAA;EAEA,iDAAA;EACA,+FAAA;EAEA,yBAAA;EACA,wDAAA;EACA,+BAAA;EAEA,aAAA;EACA,sBAAA;EAEA,4EAAA;ADGF;ACDE;EACE,aAAA;EACA,gBAAA;ADGJ;ACAE;EACE,YAAA;ADEJ;ACCE;EACE,kBAAA;EACA,gCAAA;ADCJ;ACEE;EACE,eAAA;EACA,8BAAA;ADAJ;ACGE;EACE,gBAAA;EACA,gCAAA;ADDJ;ACIE;EACE,iBAAA;EACA,iCAAA;ADFJ;ACKE;EACE,gBAAA;EACA,WAAA;ADHJ;ACME;EACE;IACE,UAAA;IACA,2BAAA;EDJJ;ECME;IACE,UAAA;IACA,wBAAA;EDJJ;AACF;ACOE;EACE;IACE,UAAA;IACA,4BAAA;EDLJ;ECOE;IACE,UAAA;IACA,wBAAA;EDLJ;AACF;ACQE;EACE;IACE,UAAA;IACA,4BAAA;EDNJ;ECQE;IACE,UAAA;IACA,wBAAA;EDNJ;AACF;ACSE;EACE;IACE,UAAA;IACA,2BAAA;EDPJ;ECSE;IACE,UAAA;IACA,wBAAA;EDPJ;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-actions-menu-sub-content {\n  .menu-content-styles();\n}\n","@import \"./../variables.less\";\n\n.popover-content-styles() {\n  min-width: 200px;\n  max-width: 512px;\n\n  padding: @layoutUnit-xs 0;\n\n  border-radius: @layoutUnit-sm;\n\n  background-color: var(--color-popover-background);\n  box-shadow: @popover-box-shadow;\n\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n\n  display: flex;\n  flex-direction: column;\n\n  max-height: calc(var(--radix-dropdown-menu-content-available-height) - @layoutUnit-md);\n\n  &__scroll-area {\n    display: flex;\n    overflow: hidden;\n  }\n\n  &__scroll-area-viewport {\n    height: auto;\n  }\n\n  &[data-side=\"top\"] {\n    margin-bottom: @layoutUnit-xs;\n    animation-name: slideDownAndFade;\n  }\n\n  &[data-side=\"bottom\"] {\n    margin-top: @layoutUnit-xs;\n    animation-name: slideUpAndFade;\n  }\n\n  &[data-side=\"right\"] {\n    margin-left: @layoutUnit-xs;\n    animation-name: slideLeftAndFade;\n  }\n\n  &[data-side=\"left\"] {\n    margin-right: @layoutUnit-xs;\n    animation-name: slideRightAndFade;\n  }\n\n  &__header {\n    padding: @layoutUnit-xs @layoutUnit-sm;\n    width: 100%;\n  }\n\n  @keyframes slideUpAndFade {\n    from {\n      opacity: 0;\n      transform: translateY(12px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slideRightAndFade {\n    from {\n      opacity: 0;\n      transform: translateX(-12px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slideDownAndFade {\n    from {\n      opacity: 0;\n      transform: translateY(-12px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slideLeftAndFade {\n    from {\n      opacity: 0;\n      transform: translateX(12px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
